/* eslint-disable arrow-body-style */
import React from 'react';
import PropTypes from 'prop-types';
import { translateElementChildren } from 'utils/translation';

const H1 = ({ children, translationKey, defaultText, ...rest }) => {
  return (
    <h1 {...rest}>
      {translateElementChildren(children, translationKey, defaultText)}
    </h1>
  );
};

H1.propTypes = {
  children: PropTypes.node.isRequired,
  translationKey: PropTypes.string,
  defaultText: PropTypes.string,
};

export default H1;
